import React from 'react'
import Scaffold from '../Scaffold/Scaffold.js'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import {createGqlClient} from '../../graphql-client.js'
import { PathRouteProps } from 'react-router'
import { gql } from '@apollo/client'
import { User } from '../../types/user.js'
import { ApplicationState } from '../../redux/store.js'

type OperatorAddFormProps = {
    dispatch: Dispatch
    user: User
} & PathRouteProps

class OperatorAddForm extends React.Component<OperatorAddFormProps,{}> {

    state = {
        name: '',
        rfid: '',
        email: '',
        message: ''
    }

    async submit(e : Event) {
        e.preventDefault()

        this.setState({
            message: ''
        })
        
        const apolloClient = createGqlClient()
        const result = await apolloClient.mutate({
            variables: {
                operator: {
                    name: this.state.name,
                    rfid: this.state.rfid,
                    email: this.state.email
                }
            },
            mutation: gql`
            mutation ($operator:CreateOperatorInputType!) {
                createOperator(operator: $operator) {
                    success
                    code
                    message
                }
              }
            `
        })

        if (result.data.createOperator.success === false) {
            this.setState({message: result.data.createOperator.message})
            return;
        }

        window.location.href = '/operators'
    }

    render() {
        return (
            <Scaffold {...this.props} autofocusSearch={false}>
                <header className="scaffold-header">Add an Operator</header>
                <header className="header-error">{this.state.message}</header>
                <form onSubmit={this.submit.bind(this)}>
                    <div>
                        <div><input autoFocus placeholder="Name" type="text" onChange={e => this.setState({name: e.target.value})}/></div>
                        <div><input placeholder="RFID" type="text" onChange={e => this.setState({rfid: e.target.value})}/></div>
                        <div><input placeholder="Email" type="text" onChange={e => this.setState({email: e.target.value})}/></div>
                    </div>
                    <button type="submit" className="primary">Add</button>
                </form>
            </Scaffold>
        )
    }
}

const mapStateToProps = ({userState} : ApplicationState) => {
    return (
    {
        user: userState.user
    })
}

export default connect(mapStateToProps)(OperatorAddForm)